<template>
  <yes-no-modal
    text="Are you sure you want to leave?"
    sub-text="All progress will be lost! Please save as a draft (if available)!"
    @back="$emit('back')"
    @submit="leave"
  />
</template>

<script>
import YesNoModal from "Components/Public/YesNoModal";
export default {
  name: "LeaveWarnModal",
  components: { YesNoModal },
  props: {
    prevRoute: Object,
  },
  methods: {
    async leave() {
      this.prevRoute.params.pass = true;
      await this.$router.push(this.prevRoute);
      this.$emit("back");
      this.prevRoute.params.pass = false;
    },
  },
};
</script>

<style scoped></style>
